//+NewRoles you can add any role you want
export const ROLES = {
    ProductManager : 'ProductManager',
    SystemAnalyst  : 'SystemAnalyst',
    Developer      : 'Developer',
    Designer       : 'Designer',
    QA             : 'QA'
}